import PageBase from '@glittr/frontend-core/src/core/v2/app/pageBase';
import DataSource from '@glittr/frontend-core/src/core/v2/data/data-source';
import Vue from 'vue';
import Int64LookupModel from '@glittr/frontend-core/src/services/v2/model/int64-lookup-model';
import GetCompaniesRequestModel from '../../../../services/v2/model/get-companies-request-model';
import LookupRequestModel from '../../../../services/v2/model/lookup-request-model';
import GuidEventLookupModel from '../../../../services/v2/model/guid-event-lookup-model';

export default class CompaniesPage extends PageBase {
  public get companiesList() {
    return this.companiesDataSource.data?.items.map((i) => { return { ...i.data }; }) || [];
  }

  public set companiesList(value) { /* Do nothing */ }

  public companiesDataSource = new DataSource({
    selectCommand: () => {
      const request = new GetCompaniesRequestModel();
      request.eventIdentifier = this.eventsDataSource.filter.eventIdentifier;
      request.selectedOrganisationId = this.organisationsDataSource.filter.selectedOrganisationId;
      request.searchCriteria = this.companiesDataSource.filter.searchCriteria;
      request.paging.currentPage = this.companiesDataSource.paging.currentPage;
      request.paging.pageSize = this.companiesDataSource.paging.pageSize;
      request.paging.includeCount = true;
      return Vue.$service.v2.api.tdg_Companies.getCompanies(request);
    },
  });

  public eventsDataSource = new DataSource({
    selectCommand: () => {
      const req = new LookupRequestModel();
      return Vue.$service.v2.api.tdg_Events.eventLookup(req);
    },
  });

  public organisationsDataSource = new DataSource({
    selectCommand: () => {
      const req = new LookupRequestModel();
      req.eventIdentifier = this.eventsDataSource.filter.eventIdentifier;
      return Vue.$service.v2.api.tdg_Organisations.lookup(req);
    },
  });

  public organisationNameItems: Int64LookupModel[] | undefined;

  public eventItems: GuidEventLookupModel[] | undefined;

  async initialize(): Promise<void> {
    await this.eventsDataSource.select();
    await this.loadEventLookup();
    await this.organisationsDataSource.select();
    await this.loadOrganisationLookup();
    await this.companiesDataSource.select();
  }

  async refreshInitialize(): Promise<void> {
    await this.organisationsDataSource.select();
    await this.loadOrganisationLookup();
    await this.companiesDataSource.select();
  }

  public companyColumns = [
    { value: Vue.$t('page.companies.table.id'), textAlign: 'left', field: 'id' },
    { value: Vue.$t('page.companies.table.companyName'), textAlign: 'left', field: 'companyName' },
    { value: Vue.$t('page.companies.table.organisationName'), textAlign: 'left', field: 'organisationName' },
    { value: Vue.$t('page.companies.table.companyContactFirstName'), textAlign: 'left', field: 'companyContactFirstName' },
    { value: Vue.$t('page.companies.table.companyContactLastName'), textAlign: 'left', field: 'companyContactLastName' },
    { value: Vue.$t('page.companies.table.companyContactPhoneNumber'), textAlign: 'left', field: 'companyContactPhoneNumber' },
    { value: Vue.$t('page.companies.table.companyContactEmail'), textAlign: 'left', field: 'companyContactEmail' },
    { value: '', field: 'actions' },
  ];

  gotoDetail(id: string | number) {
    Vue.$router.push(`/_admin/companies/edit/${id}`);
  }

  async refreshCompanies() {
    try {
      await this.refreshInitialize();
    } catch (error) {
      Vue.$log.error(`Error refreshing companies: ${error}`);
    }
  }

  async loadOrganisationLookup() {
    try {
      if (this.organisationsDataSource.data) {
        const res = this.organisationsDataSource.data;
        this.organisationNameItems = res.items.map((i: { data: any; }) => i.data);
      }
    } catch (error) {
      Vue.$log.error('Failed to load organisations:');
    }
  }

  async loadEventLookup() {
    if (this.eventsDataSource.data) {
      const res = this.eventsDataSource.data;

      this.eventItems = res.items.map((i) => {
        const model = new GuidEventLookupModel();
        model.id = i.data.id;
        model.caption = i.data.caption;
        return model;
      });

      if (this.eventItems.length > 0) {
        const lastItem = this.eventItems[this.eventItems.length - 1];
        this.eventsDataSource.filter.eventIdentifier = lastItem.id;
      }
    }
  }
}
